import { Anchor, List, Stack, Text, Title } from "@mantine/core";
import { Section } from "$/components/section";
import { WHATSAPP_URL } from "$/data/links";

export default function TermsPage() {
  return (
    <Section>
      <Stack gap="xl" pt={64}>
        <Stack gap="xs">
          <Title order={1}>Termos de Uso</Title>
          <Text c="gray.6" fz="sm">
            Última atualização: 18 de maio de 2026
          </Text>
        </Stack>

        <Stack gap="md">
          <Title order={2} fz="h3">
            1. Aceitação dos termos
          </Title>
          <Text c="gray.7">
            Ao instalar, acessar ou utilizar o Verdana (o "Software"), você concorda com estes
            Termos de Uso. Se você não concorda com qualquer parte destes termos, não utilize o
            Software.
          </Text>
        </Stack>

        <Stack gap="md">
          <Title order={2} fz="h3">
            2. Sobre o Verdana
          </Title>
          <Text c="gray.7">
            O Verdana é um sistema de gestão (mini-ERP) desktop voltado para Microempreendedores
            Individuais (MEI) e pequenos negócios brasileiros. O Software é instalado localmente no
            computador do usuário e seus dados ficam armazenados na máquina onde o programa é
            executado, salvo quando o usuário optar por integrações ou serviços adicionais.
          </Text>
        </Stack>

        <Stack gap="md">
          <Title order={2} fz="h3">
            3. Licença de uso
          </Title>
          <Text c="gray.7">
            Concedemos a você uma licença pessoal, intransferível, não exclusiva e revogável para
            utilizar o Verdana de acordo com o plano contratado. Esta licença não transfere a
            propriedade do Software, que permanece com a equipe Verdana.
          </Text>
          <List spacing="xs" c="gray.7">
            <List.Item>
              É permitido instalar e utilizar o Software no número de máquinas previsto no plano
              contratado.
            </List.Item>
            <List.Item>
              É vedado copiar, redistribuir, sublicenciar, alugar ou comercializar o Software.
            </List.Item>
            <List.Item>
              É vedada a engenharia reversa, descompilação ou tentativa de extrair o código-fonte,
              exceto quando expressamente permitido por lei.
            </List.Item>
          </List>
        </Stack>

        <Stack gap="md">
          <Title order={2} fz="h3">
            4. Responsabilidades do usuário
          </Title>
          <Text c="gray.7">O usuário é o único responsável por:</Text>
          <List spacing="xs" c="gray.7">
            <List.Item>Manter cópias de segurança (backups) dos seus dados.</List.Item>
            <List.Item>
              Garantir a veracidade e legalidade das informações inseridas no Software.
            </List.Item>
            <List.Item>
              Cumprir a legislação aplicável ao seu negócio, incluindo obrigações fiscais e
              tributárias.
            </List.Item>
            <List.Item>
              Manter o equipamento, sistema operacional e periféricos em condições adequadas para o
              uso do Software.
            </List.Item>
          </List>
        </Stack>

        <Stack gap="md">
          <Title order={2} fz="h3">
            5. Pagamento e renovação
          </Title>
          <Text c="gray.7">
            O acesso ao Verdana pode ser oferecido em modalidades de assinatura ou licença perpétua,
            conforme o plano vigente no momento da contratação. Valores, formas de pagamento e
            condições serão informados antes da contratação. A falta de pagamento pode resultar na
            suspensão ou no encerramento da licença.
          </Text>
        </Stack>

        <Stack gap="md">
          <Title order={2} fz="h3">
            6. Atualizações e suporte
          </Title>
          <Text c="gray.7">
            Podemos disponibilizar atualizações para corrigir falhas, melhorar funcionalidades ou
            adequar o Software a mudanças legais. O suporte técnico é prestado pelos canais oficiais
            divulgados em nosso site, conforme o plano contratado.
          </Text>
        </Stack>

        <Stack gap="md">
          <Title order={2} fz="h3">
            7. Limitação de responsabilidade
          </Title>
          <Text c="gray.7">
            O Verdana é fornecido "no estado em que se encontra". Embora trabalhemos para entregar
            um produto estável e confiável, não garantimos que o Software estará livre de erros ou
            que atenderá a todas as necessidades específicas do seu negócio. Na máxima extensão
            permitida pela legislação, não nos responsabilizamos por lucros cessantes, perda de
            dados, interrupção de atividades ou prejuízos indiretos decorrentes do uso ou da
            impossibilidade de uso do Software.
          </Text>
        </Stack>

        <Stack gap="md">
          <Title order={2} fz="h3">
            8. Propriedade intelectual
          </Title>
          <Text c="gray.7">
            Todos os direitos de propriedade intelectual sobre o Software, sua marca, layout,
            código, documentação e materiais relacionados pertencem à equipe Verdana. Nada nestes
            Termos transfere tais direitos ao usuário.
          </Text>
        </Stack>

        <Stack gap="md">
          <Title order={2} fz="h3">
            9. Encerramento
          </Title>
          <Text c="gray.7">
            Podemos suspender ou encerrar a licença em caso de descumprimento destes Termos. O
            usuário pode encerrar o uso a qualquer momento desinstalando o Software. Em qualquer
            hipótese de encerramento, recomenda-se exportar previamente os dados que considerar
            relevantes.
          </Text>
        </Stack>

        <Stack gap="md">
          <Title order={2} fz="h3">
            10. Alterações destes Termos
          </Title>
          <Text c="gray.7">
            Estes Termos podem ser atualizados periodicamente. Quando isso ocorrer, a nova versão
            será publicada nesta página com data de atualização. O uso contínuo do Software após a
            publicação representa concordância com os termos revisados.
          </Text>
        </Stack>

        <Stack gap="md">
          <Title order={2} fz="h3">
            11. Lei aplicável e foro
          </Title>
          <Text c="gray.7">
            Estes Termos são regidos pelas leis da República Federativa do Brasil. Fica eleito o
            foro da comarca de Garanhuns/PE para dirimir quaisquer controvérsias decorrentes do uso
            do Software, ressalvadas as hipóteses legais de foro privilegiado.
          </Text>
        </Stack>

        <Stack gap="md">
          <Title order={2} fz="h3">
            12. Contato
          </Title>
          <Text c="gray.7">
            Dúvidas sobre estes Termos podem ser enviadas pelo nosso{" "}
            <Anchor href={WHATSAPP_URL} target="_blank" rel="noopener">
              WhatsApp
            </Anchor>
            .
          </Text>
        </Stack>
      </Stack>
    </Section>
  );
}
